import React from 'react'
import { useTranslation } from 'react-i18next'
import { ContainerQuery } from 'react-container-query'
import classNames from 'classnames'
import { Offer } from 'cityads-v3/types/offers'
import classes from './OfferCard.scss'

import Category from 'cityads-v3/components/Format/Category'
import SubscriptionStatus from 'cityads-v3/components/Format/SubscriptionStatus'
import Typography from '@mui/material/Typography'

const responsiveQuery = {
  dense: {
    maxWidth: 485
  }
}

type OfferCardHeaderProps = {
  className?: string
  manualFetch?: boolean
  offer: Offer
}

export default function OfferCardHeader({
  offer,
  className,
  manualFetch = false
}: OfferCardHeaderProps) {
  const { t } = useTranslation(['Offers']);

  return (
    <ContainerQuery query={responsiveQuery}>
      {params => (
        <div className={classNames(classes.offerHeader, className, {
          [classes['offerHeader__dense']]: params.dense
        })}>
          <SubscriptionStatus id={offer?.subscription_status} manualFetch={manualFetch}>
            {name => (
              <div className={classes.trafficType}>
                <Typography color="textSecondary">
                  {t('status')}:{' '}
                  <Typography color="textPrimary" component="span">{name}</Typography>
                </Typography>
              </div>
            )}
          </SubscriptionStatus>

          {offer?.business_category
            ? (
              <Category id={offer.business_category} manualFetch={manualFetch}>
                {name => (
                  <div className={classes.trafficType}>
                    <Typography color="textSecondary">
                      {t('category')}:{' '}
                      <Typography color="textPrimary" component="span">{name}</Typography>
                    </Typography>
                  </div>
                )}
              </Category>
            )
            : null}
        </div>
      )}
    </ContainerQuery>
  )
}
